module.exports = __webpack_public_path__ + "23a6d386db910564b48453809f3fe861.svg";